<template>
  <div class="s-professionalInfoConsultationAdvisoryDetails-container">
    <topNav></topNav>
    <div class="content w1300 marginAuto marginTop110">
      <div class="crumbs">
        <img src="../assets/image/index/home.png" class="img" alt />
        <span @click="crumbsGoRoute('index')" class="go">首页&gt;</span>
        <span @click="crumbsGoRoute('dealmakers')" class="go"
          >交易撮合&gt;</span
        >
        <span>交易撮合详情</span>
      </div>
      <div class="expert-introduction-wrap">
        <div class="expert-baseinfo-imglist">
          <el-image
            v-for="(item, index) in imgList"
            :key="index"
            :src="item"
            :preview-src-list="imgList"
            class="expert-baseinfo-img"
          >
          </el-image>
        </div>
        <div class="expert-baseinfo-wrap">
          <el-row>
            <el-col :span="24">
              <span class="title red">{{
                dealmakersDetailsData.transactionType
                  ? dealmakersDetailsData.transactionType
                  : "--"
              }}</span>
              <span class="title margin_left">{{
                dealmakersDetailsData.transactionTitle
                  ? dealmakersDetailsData.transactionTitle
                  : "--"
              }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <span class="column_span"
                >发布人：{{
                  dealmakersDetailsData.contacts
                    ? dealmakersDetailsData.contacts
                    : "--"
                }}</span
              >
              <span class="column_span margin_left"
                >发布日期：{{
                  dealmakersDetailsData.transactionDate
                    ? dealmakersDetailsData.transactionDate
                    : "--"
                }}</span
              >
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-card class="box-card">
                <el-row>
                  <el-col :span="8">
                    <span class="column_span column_bold"
                      >产品分类：{{
                        dealmakersDetailsData.classifyValue
                          ? dealmakersDetailsData.classifyValue
                          : "--"
                      }}</span
                    >
                  </el-col>
                  <el-col :span="8">
                    <span class="column_span column_bold"
                      >产品名称：{{
                        dealmakersDetailsData.varietiesValue
                          ? dealmakersDetailsData.varietiesValue
                          : "--"
                      }}</span
                    >
                  </el-col>
                  <el-col :span="8">
                    <span class="column_span column_bold"
                      >产品类型：{{
                        dealmakersDetailsData.productTypeValue
                          ? dealmakersDetailsData.productTypeValue
                          : "--"
                      }}</span
                    >
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <span class="column_span column_bold"
                      >价格：<span class="column_span column_bold red">{{
                        dealmakersDetailsData.transactionPrice
                          ? dealmakersDetailsData.transactionPrice
                          : "--"
                      }}</span>
                      {{dealmakersDetailsData.priceUnit}}</span
                    >
                  </el-col>
                  <el-col :span="12">
                    <span class="column_span column_bold"
                      >数量：<span class="column_span column_bold red"
                        >{{
                          dealmakersDetailsData.transactionNumber
                            ? dealmakersDetailsData.transactionNumber
                            : "--"
                        }} </span
                      >{{dealmakersDetailsData.numberUnit}}</span
                    >
                  </el-col>
                  <el-col :span="8"> </el-col>
                </el-row>
              </el-card>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <span class="column_span"
                >交易地区：{{ address ? address : "--" }}</span
              >
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <span class="column_span"
                >详细地址：{{
                  dealmakersDetailsData.address
                    ? dealmakersDetailsData.address
                    : "--"
                }}</span
              >
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <span class="column_span"
                >发布人：{{
                  dealmakersDetailsData.contacts
                    ? dealmakersDetailsData.contacts
                    : "--"
                }}</span
              >
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <span class="column_span">
                联系电话：
                <span v-if="isShowPhone">
                  {{
                    dealmakersDetailsData.contactsPhone
                      ? dealmakersDetailsData.contactsPhone
                      : "--"
                  }}
                </span>
                <span v-else>
                  {{ hidePhone }}
                  <el-button size="mini" class="loginBtn" @click="login"
                    >登录后查看
                  </el-button>
                </span>
              </span>
            </el-col>
          </el-row>
          <!-- <div class="transactions-release-body">

            <div class="dealmakersDetails_item">
              <span class="dealmakersDetails_label">标题：</span>
              <div class="dealmakersDetails_content">
                {{ dealmakersDetailsData.transactionTitle ? dealmakersDetailsData.transactionTitle : "--" }}
              </div>
            </div>

            <div class="dealmakersDetails_item">
              <span class="dealmakersDetails_label">产品类型：</span>
              <div class="dealmakersDetails_content">
                {{ dealmakersDetailsData.productTypeId ? dealmakersDetailsData.productTypeValue : "--" }}
              </div>
            </div>

            <div class="dealmakersDetails_item">
              <span class="dealmakersDetails_label">地区：</span>
              <div class="dealmakersDetails_content">

                      <el-select
                          v-model="dealmakersDetailsData.pronince"
                          placeholder="请选择"
                          class="region_select"
                          disabled
                          @change="selectListRegion($event,'市')"
                      >
                        <el-option
                            v-for="item in provinceData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                      </el-select>

                      <el-select
                          v-model="dealmakersDetailsData.city"
                          placeholder="请选择"
                          class="region_select"
                          disabled
                          @change="selectListRegion($event,'县')"
                      >
                        <el-option
                            v-for="item in cityData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                      </el-select>

                      <el-select
                          v-model="dealmakersDetailsData.county"
                          placeholder="请选择"
                          disabled
                          class="region_select">
                        <el-option
                            v-for="item in countyData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                      </el-select>

              </div>
            </div>

            <div class="dealmakersDetails_item">
              <span class="dealmakersDetails_label">品种名称：</span>
              <div class="dealmakersDetails_content">
                {{ dealmakersDetailsData.varietiesId ? dealmakersDetailsData.varietiesId : "--" }}
              </div>
            </div>
            <div class="dealmakersDetails_item">
              <span class="dealmakersDetails_label">详细地址：</span>
              <div class="dealmakersDetails_content">
                {{ dealmakersDetailsData.address ? dealmakersDetailsData.address : "--" }}
              </div>
            </div>
            <div class="dealmakersDetails_item">
              <span class="dealmakersDetails_label">产品品种：</span>
              <div class="dealmakersDetails_content">
                {{ dealmakersDetailsData.classifyId ? dealmakersDetailsData.classifyId : "--" }}
              </div>
            </div>
            <div class="dealmakersDetails_item">
              <span class="dealmakersDetails_label">发布人：</span>
              <div class="dealmakersDetails_content">
                {{ dealmakersDetailsData.contacts ? dealmakersDetailsData.contacts : "--" }}
              </div>
            </div>
            <div class="dealmakersDetails_item">
              <span class="dealmakersDetails_label">交易类型：</span>
              <div class="dealmakersDetails_content">
                {{ dealmakersDetailsData.transactionType ? dealmakersDetailsData.transactionType : "--" }}
              </div>
            </div>
            <div class="dealmakersDetails_item">
              <span class="dealmakersDetails_label">联系电话：</span>
              <div class="dealmakersDetails_content">
                {{ dealmakersDetailsData.contactsPhone ? dealmakersDetailsData.contactsPhone : "--" }}
              </div>
            </div>
            <div class="dealmakersDetails_item">
              <span class="dealmakersDetails_label">数量：</span>
              <div class="dealmakersDetails_content">
                {{ dealmakersDetailsData.transactionNumber ? dealmakersDetailsData.transactionNumber : "--" }}
              </div>
            </div>
            <div class="dealmakersDetails_item">
              <span class="dealmakersDetails_label">价格：</span>
              <div class="dealmakersDetails_content">
                {{ dealmakersDetailsData.transactionPrice ? dealmakersDetailsData.transactionPrice : "--" }}元/公斤
              </div>
            </div>
            <div class="dealmakersDetails_item">
              <span class="dealmakersDetails_label">日期：</span>
              <div class="dealmakersDetails_content">
                {{ dealmakersDetailsData.transactionDate ? dealmakersDetailsData.transactionDate : "--" }}
              </div>
            </div>
            <div class="dealmakersDetails_item">
              <span class="dealmakersDetails_label">图片：</span>
              <div class="dealmakersDetails_content">
                <img
                    v-if="dealmakersDetailsData.img"
                    :src="imgURL+'/'+dealmakersDetailsData.img"
                    class="avatar"
                />
              </div>
            </div>

          </div> -->
        </div>
      </div>
    </div>
    <footer-nav></footer-nav>
  </div>
</template>

<script>
import topNav from "../components/topNav.vue";
import footerNav from "../components/footerNav.vue";
import { selectListRegion, transactionGetById } from "@/utils/api/dealmakers";
import eventBus from "../utils/js/eventBus.js";
export default {
  name: "dealmakersDetails",
  data() {
    return {
      dealmakersDetailsData: {
        transactionTitle: "", // 标题
        productTypeId: "", // 产品分类
        varietiesId: "", // 产品名称
        classifyId: "", // 产品品种
        transactionType: "", // 交易类型
        contacts: "", // 发布人
        contactsPhone: "", // 联系电话
        transactionNumber: "", // 数量
        img: "", // 图片
        transactionPrice: "", // 价格
        transactionDate: "", // 交易日期
        pronince: "",
        city: "",
        county: "",
        address: "", // 详细地址
      },
      imgList: [],
      address: "",
      isShowPhone: null,
      provinceData: [], // 省数据
      cityData: [], // 市数据
      countyData: [], // 区数据
    };
  },
  components: { topNav, footerNav },
  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    this.isShowPhone = localStorage.getItem("token") == null ? false : true;
    this.getDealmakersDetailsData();
    // this.selectListRegion(0, "省");
  },
  computed: {
    hidePhone: function () {
      const newarr = this.dealmakersDetailsData.contactsPhone.split("");
      newarr.forEach((item, index, arr) => {
        if (index > 2 && index < 7) {
          arr[index] = "*";
        }
      });
      return newarr.join("");
    },
  },
  methods: {
    // 省市区联动
    async selectListRegion(pid, name) {
      let res = await selectListRegion({
        orderBy: { id: "asc" },
        pid,
      });
      if (res.data.code == 0) {
        if (name == "省") {
          this.provinceData = res.data.data;
          this.selectListRegion(this.provinceData[0].id, "市");
        }
        if (name == "市") {
          this.cityData = res.data.data;
          this.dealmakersDetailsData.city = "";
          this.dealmakersDetailsData.county = "";

          if (this.dealmakersDetailsData.city != "") {
            this.selectListRegion(this.dealmakersDetailsData.city, "县");
          } else {
            this.selectListRegion(this.cityData[0].id, "县");
          }
          if (this.dealmakersDetailsData.city != "") {
            this.selectListRegion(this.dealmakersDetailsData.city, "县");
          } else {
            this.selectListRegion(this.cityData[0].id, "县");
          }
          this.dealmakersDetailsData.city = "";
          this.dealmakersDetailsData.county = "";
        }
        if (name == "县") {
          this.dealmakersDetailsData.county = "";
          this.countyData = res.data.data;
        }
      }
    },

    async getDealmakersDetailsData() {
      let res = await transactionGetById({ id: this.id });
      if (res.data.code == 0) {
        // this.selectListRegion(res.data.data.pronince,'市')
        // this.selectListRegion(res.data.data.city,'县')
        // setTimeout(function(){
        this.dealmakersDetailsData = res.data.data;
        console.log("this.dealmakersDetailsData", this.dealmakersDetailsData);
        // 图片
        if (this.dealmakersDetailsData.img) {
          this.imgList = this.dealmakersDetailsData.img.split(",");
        }
        if (this.imgList.length < 1) {
          // this.imgList.push("#");
          this.imgList = [require("../assets/image/dealmakers/default.png")];
        } else {
          this.imgList = this.imgList.map((item, index) => {
            if(item.indexOf('http') == -1){
              return this.imgURL + '/' + item;
            }
            return item;
          });
        }
        // 地址
        this.address =
          (this.dealmakersDetailsData.proninceValue
            ? this.dealmakersDetailsData.proninceValue + "-"
            : "") +
          (this.dealmakersDetailsData.cityValue
            ? this.dealmakersDetailsData.cityValue + "-"
            : "") +
          (this.dealmakersDetailsData.countyValue
            ? this.dealmakersDetailsData.countyValue
            : "");
        if (this.address === "") {
          this.address = "--";
        }
        console.log("this.dealmakersDetailsData:", this.dealmakersDetailsData);
        // },1500)
      }
    },
    crumbsGoRoute(path) {
      this.$router.push({ path });
    },
    login() {
      eventBus.$emit("loginClick", true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../utils/css/common.scss";
@import "../utils/css/dealmakersDetails.scss";

// .transactions-release-body {
//   height: 550px;

//   .transactions-form-item {
//     width: 35%;
//     float: left;
//     margin-right: 15%;
//   }

//   .dealmakersDetails_item {
//     width: 50%;
//     float: left;
//     display: flex;
//     justify-content: flex-start;
//     //margin-left: 5%;
//     height: 60px;
//     line-height: 60px;

//     .dealmakersDetails_label {
//       text-align: right;
//       vertical-align: middle;
//       float: left;
//       font-size: 16px;
//       color: #606266;
//       padding: 0 12px 0 0;
//       width: 100px;
//     }

//     .dealmakersDetails_content {
//       text-align: right;
//       vertical-align: middle;
//       font-size: 16px;
//       color: #606266;
//       .region_select {
//         width: 150px;
//         margin-right: 10px;
//       }
//     }
//   }
// }

// .transactions-form-regon {
//   .el-select {
//     width: 98%;
//   }
// }

// .transactions-release-footer {
//   display: flex;
//   justify-content: center;

//   .transactions-release-close {
//     width: 129px;
//     height: 35px;
//     border: 1px solid #54ae49;
//     background: #fff;
//     border-radius: 6px;
//     font-size: 18px;
//     font-family: PingFangSC;
//     font-weight: 400;
//     color: #28bd4e;
//     line-height: 35px;
//     text-align: center;
//     cursor: pointer;
//   }

//   .transactions-release-sure {
//     width: 129px;
//     height: 35px;
//     border: 1px solid #54ae49;
//     background: linear-gradient(90deg, #1cba4d, #a1dc61);
//     border-radius: 6px;
//     font-size: 18px;
//     font-family: PingFangSC;
//     font-weight: 400;
//     color: #ffffff;
//     line-height: 35px;
//     text-align: center;
//     margin-left: 100px;
//     cursor: pointer;
//   }
// }

// .avatar-uploader .el-upload {
//   border: 1px dashed #d9d9d9;
//   border-radius: 6px;
//   cursor: pointer;
//   position: relative;
//   overflow: hidden;
// }

// .avatar-uploader .el-upload:hover {
//   border-color: #409eff;
// }

// .avatar-uploader-icon {
//   font-size: 28px;
//   color: #8c939d;
//   width: 155px;
//   height: 155px;
//   line-height: 155px;
//   text-align: center;
//   border: 1px solid #e5e5e5;
// }

// .avatar {
//   width: 240px;
//   height: 170px;
//   display: block;
//   margin-top: 20px;
// }
</style>
